import React, { CSSProperties, useState } from "react";

import { Grid } from "semantic-ui-react";

import LoadingScreen from "react-lib/apps/HISV3/common/LoadingScreen";

import EmailRegisterForm from "./EmailRegisterForm";
import EmailVerificationForm from "./EmailVerificationForm";
import LandingContainer from "./LandingContainer";
import LoginForm from "./LoginForm";

type MeHealthLandingProps = {
  setProp: (key: string, value: any, callback?: () => void) => any;
  controller?: any;
  AppInitializeSequence: any;
  facebookLogin?: (name: string) => void;
  loadingLogin?: boolean;
  onLoginSubmit: () => void;
  onLoginSuccess: (res: any) => void;
};

type ViewType = "fb-loading" | "login" | "register" | "verification";

type Styles = Record<"leftSection" | "rightSection", CSSProperties>;

const IMAGES = {
  banner: "/static/images/landing/mehealth-banner.png",
} as const;

const styles: Styles = {
  leftSection: {
    alignItems: "center",
    background: "var(--dark-bg-color)",
    display: "flex",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "2rem",
  },
  rightSection: {
    alignItems: "center",
    backgroundColor: "#ffffff",
    display: "flex",
    height: "100vh",
    justifyContent: "center",
    overflowX: "hidden",
    overflowY: "auto",
    padding: "1rem",
  },
};

const MeHealthLanding = (props: MeHealthLandingProps) => {
  const [currentView, setCurrentView] = useState<ViewType>("login");
  const [email, setEmail] = useState<string>("");

  const handleEmailRegister = (inputEmail: string) => {
    setEmail(inputEmail);
    setCurrentView("register");
  };

  const handleRegisterSuccess = (inputEmail: string) => {
    setEmail(inputEmail);

    setCurrentView("verification");
  };

  const handleEmailSuccess = (inputEmail: string) => {
    setEmail(inputEmail);
    setCurrentView("verification");
  };

  const handleLoginLoading = (isLoading: boolean) => {
    setCurrentView(isLoading ? "fb-loading" : "login");
  };

  return currentView === "fb-loading" ? (
    <LoadingScreen />
  ) : (
    <Grid style={{ margin: 0, minHeight: "100vh", overflow: "hidden" }}>
      <Grid.Column style={styles.leftSection} width={8}>
        <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
          <img style={{ height: "55vh" }} alt="landing" src={IMAGES.banner} />
        </div>
      </Grid.Column>

      <Grid.Column style={styles.rightSection} width={8}>
        {currentView === "login" && (
          <LandingContainer>
            <LoginForm
              setProp={props.setProp}
              controller={props.controller}
              AppInitializeSequence={props.AppInitializeSequence}
              facebookLogin={props.facebookLogin}
              loadingLogin={props.loadingLogin}
              onEmailRegister={handleEmailRegister}
              onEmailSuccess={handleEmailSuccess}
              onLoginLoading={handleLoginLoading}
              onLoginSubmit={props.onLoginSubmit}
              onLoginSuccess={props.onLoginSuccess}
            />
          </LandingContainer>
        )}

        {currentView === "register" && (
          <LandingContainer
            subtitle="Email"
            subtitleStyle={{ color: "" }}
            title="สร้างบัญชีใหม่ด้วย"
          >
            <EmailRegisterForm email={email} onSuccess={handleRegisterSuccess} />
          </LandingContainer>
        )}

        {currentView === "verification" && (
          <LandingContainer subtitle="Email" subtitleStyle={{ color: "" }} title="ยืนยัน">
            <EmailVerificationForm email={email} onSuccess={props.onLoginSuccess} />
          </LandingContainer>
        )}
      </Grid.Column>
    </Grid>
  );
};

MeHealthLanding.displayName = "Landing";

export default React.memo(MeHealthLanding);
